import React, { useState, useRef, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import './Navigation.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
const Navigation = () => {
	const [toggleMenu, setToggleMenu] = useState(false)
	const { signout, isAdmin } = useAuth()
	const history = useHistory()
	const ref = useRef()
	useEffect(() => {
		const checkIfClickedOutside = (e) => {
			if (toggleMenu && ref.current && !ref.current.contains(e.target)) {
				setToggleMenu(false)
			}
		}
		document.addEventListener('mousedown', checkIfClickedOutside)
		return () => {
			document.removeEventListener('mousedown', checkIfClickedOutside)
		}
	}, [toggleMenu])
	const handleLogOut = async () => {
		try {
			await signout()
			history.push('/signin')
		} catch (error) {
			console.error(error)
			alert('error')
		}
	}
	return (
		<>
			<div className="Navigation">
				<div onClick={() => setToggleMenu((prevSwitch) => !prevSwitch)}>
					<FontAwesomeIcon icon={faBars} />
				</div>
				<div onClick={() => handleLogOut()}>
					Logga ut <FontAwesomeIcon icon={faSignOutAlt} />
				</div>
			</div>
			{toggleMenu ? (
				<div ref={ref} className="Menu">
					{isAdmin ? (
						<>
							<Link
								onClick={() =>
									setToggleMenu((prevSwitch) => !prevSwitch)
								}
								to="/register"
							>
								<div>Kassa</div>
							</Link>
							<Link
								onClick={() =>
									setToggleMenu((prevSwitch) => !prevSwitch)
								}
								to="/customers"
							>
								<div>Kunder</div>
							</Link>
							<Link
								onClick={() =>
									setToggleMenu((prevSwitch) => !prevSwitch)
								}
								to="/statistics"
							>
								<div>Statistik</div>
							</Link>
						</>
					) : (
						<>
							<Link
								onClick={() =>
									setToggleMenu((prevSwitch) => !prevSwitch)
								}
								to="/profile"
							>
								<div>Profil</div>
							</Link>
							<Link
								onClick={() =>
									setToggleMenu((prevSwitch) => !prevSwitch)
								}
								to="/sales"
							>
								<div>Försäljning</div>
							</Link>
						</>
					)}
				</div>
			) : null}
		</>
	)
}

export default Navigation
